<template>
    <div class="faq-questions-area" v-if="faq_data">
        <div class="col-12 col-sm-12 col-md-12">
            <div id="accordion6" class="panel-group accordion"  role="tablist" aria-multiselectable="true">   
                <vue-aos animation-class="fadeInUp animated" :threshold="indx/10" v-for="(item, indx) of faq_data" :key="indx">
                    <div class="panel panel-default" >
                        <div class="panel-heading" role="tab" :id="`headingOne_${indx}`">
                            <h4 class="panel-title">
                                <a class="btn btn-link text-left" :class="indx >= 1 ? 'collapsed' : ''" data-toggle="collapse" :data-target="`#collapseOne_${indx}`" aria-expanded="false" :aria-controls="`collapseOne_${indx}`">
                                {{ item.question }}
                                </a>                                
                            </h4>
                        </div>

                        <div :id="`collapseOne_${indx}`" class="collapse"  :class="indx < 1 ? 'show' : ''" :aria-labelledby="`headingOne_${indx}`" data-parent="#accordion6">
                            <div class="panel-body" v-html="item.answer"></div>
                        </div>
                    </div> 
                </vue-aos>      
            </div>
        </div>        
    </div>
</template>

<script>
import VueAos from 'vue-aos'
import 'bootstrap';
export default {
    components: {
        VueAos
    },
    props: {
        faqData: Array
    },
    data(){
        return {
            faq_data: []
        }
    },
    methods: {
        toggleTab(event){
            let element = event.target,
                collapseEl = element.getAttribute('href')
            document.querySelectorAll('.panel-collapse').forEach(el=>{
                el.classList.remove('show')
            })
            document.querySelectorAll('.panel-title a').forEach(el=>{
                el.classList.add('collapsed')
            })
            document.querySelector(collapseEl).classList.add('show')
            element.classList.remove('collapsed')
        }
    },
    created: function(){
        this.faq_data = this.$props.faqData
    },
    watch: {
        "$props.faqData"(){
            this.faq_data = this.$props.faqData
        }
    }
}
</script>